import Header from "../layout/Header";
import Footer from "../layout/Footer";
import { useSEO } from "../hooks/useSEO";

const ContactBlock = ({
    title,
    description,
    email,
}: {
    title: string;
    description: string;
    email: string;
}) => (
    <div className="border-t border-black/20 py-8 text-center">
        <h2 className="font-caviar font-bold text-[20px] text-black mb-4">
            {title}
        </h2>

        <p className="font-productsans text-[15px] leading-[1.7] text-black/80 mb-3">
            {description}
        </p>

        <a
            href={`mailto:${email}`}
            className="font-productsans text-[15px] text-black underline underline-offset-4 hover:opacity-70 transition"
        >
            {email}
        </a>
    </div>
);

export default function ContactUs() {
    useSEO({
        title: "Contact Vastavik — Support & Enquiries",
        description:
            "Get in touch with Vastavik for support, partnerships and media authenticity enquiries. We're here to help creators protect and verify their content.",
        path: "/contactus",
        keywords: "contact Vastavik, Vastavik support, media authenticity enquiries",
    });
    return (
        <div className="min-h-screen bg-white flex flex-col text-black">
            <Header />

            <main className="flex-1 px-6 md:px-10 pt-16 md:pt-20 pb-14">
                <div className="max-w-[920px] mx-auto">
                    {/* Heading */}
                    <div className="text-center">
                        <h1 className="font-caviar font-bold text-[42px] sm:text-[52px] tracking-tight text-black">
                            Contact Us
                        </h1>

                        <div className="mt-8 space-y-1">
                            <p className="font-productsans text-[16px] md:text-[17px] leading-[1.8] text-black/85">
                                VASTAVIK helps creators, media professionals, and organisations
                                protect and verify authenticity.
                            </p>

                            <p className="font-productsans text-[16px] md:text-[17px] leading-[1.8] text-[#e53935]">
                                Reach out to the right team below.
                            </p>

                            <p className="font-productsans text-[16px] md:text-[17px] leading-[1.8] text-black/85 pt-1">
                                We usually respond within 24–48 hours on business days.
                            </p>
                        </div>
                    </div>

                    {/* Contact Blocks */}
                    <div className="mt-16">
                        <ContactBlock
                            title="General enquiries"
                            description="Questions about the platform, partnerships, or access."
                            email="info@vastavik.org"
                        />

                        <ContactBlock
                            title="Creators"
                            description="Support for uploads, verification, and Creator IDs."
                            email="support@vastavik.org"
                        />

                        <ContactBlock
                            title="Press & events"
                            description="Media enquiries, interviews, and speaking requests."
                            email="info@vastavik.org"
                        />

                        {/* <div className="border-t border-black/20" /> */}
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}